// src/components/ContactForm.tsx
'use client';

import { useState } from 'react';
import styles from './ContactPage.module.css';

export default function ContactForm() {
  // ✅ Extended form state
  const [form, setForm] = useState({
    name: '',
    email: '',
    company: '',
    referralSource: '',
    message: '',
  });

  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  // ✅ Handle changes to all inputs
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // ✅ Handle form submission
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(form),
      });

      if (!res.ok) throw new Error('Email not sent');

      console.log('✅ Email sent!');
      setSubmitted(true);
    } catch (err) {
      console.error('❌ Submission failed:', err);
      alert('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // ✅ Success message
  if (submitted) {
    return (
      <div className={styles.thankYou}>
        <h2>Thanks for reaching out — we’ll get back to you shortly.</h2>
      </div>
    );
  }

  // ✅ Render form with added fields
  return (
    <form onSubmit={handleSubmit} className={styles.form}>
      <input
        name="name"
        type="text"
        placeholder="Your Name"
        value={form.name}
        onChange={handleChange}
        required
      />

      <input
        name="email"
        type="email"
        placeholder="Your Email"
        value={form.email}
        onChange={handleChange}
        required
      />

      <input
        name="company"
        type="text"
        placeholder="Company Name (optional)"
        value={form.company}
        onChange={handleChange}
      />

      <select
        name="referralSource"
        value={form.referralSource}
        onChange={handleChange}
        required
      >
        <option value="">How did you hear about us?</option>
        <option value="LinkedIn">LinkedIn</option>
        <option value="Referral">Referral</option>
        <option value="Search Engine">Search Engine</option>
        <option value="Event">Event / Meetup</option>
        <option value="Other">Other</option>
      </select>

      <textarea
        name="message"
        placeholder="Your Message"
        value={form.message}
        onChange={handleChange}
        rows={6}
        required
      />

      <button type="submit" disabled={loading}>
        {loading ? 'Sending...' : 'Send Message'}
      </button>
    </form>
  );
}
